module.exports = __webpack_public_path__ + "static/img/MuchoQueVer.165a71b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MuchoQueVer.png
// module id = xaVR
// module chunks = 1